import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';
import { BrandBlue } from '../../constants/Colors';

export const RotateKeyframeAnim = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
`;

const AnimatedIconContainer = styled.span`
  display: inline-block;
  animation: ${RotateKeyframeAnim} .8s infinite linear;
`;

let Container = styled.div`
  display: inline-block;
  text-align: center;
`;

const Title = styled.div`
  padding: 5px;
  font-size: 14px;
  color: black;
  text-align: center;
  font-weight: 600;
`;

const LoadingIndicator = ({ size, title, block, color }) => {

  let testId = 'loading-indicator';

  if (block) {
    testId = 'loading-indicator-block';
    Container = styled(Container)`
      display: block;
    `;
  }

  return (
    <Container data-testid={testId}>
      <AnimatedIconContainer>
        <Icon
          icon={faSpinner}
          color={color || BrandBlue}
          size={size}
          extraProps={{ 'data-testid': 'loading-icon' }}
        />
      </AnimatedIconContainer>

      {title ? <Title>{title}</Title> : null}
    </Container>
  );
};

LoadingIndicator.propTypes = {
  size: PropTypes.oneOf(['lg', 'md', 'sm']),
  title: PropTypes.string,
  // Block is used for loading indicators nested in
  // non-explicitly centered elements
  block: PropTypes.bool,
};

export default LoadingIndicator;
